import React from 'react';

const Fees = () => {
	return <h1>Fees</h1>;
};

export default Fees;
